export default __webpack_public_path__ + "static/media/plovbg.8de3b1a8.mp4";